import { useEffect, useRef, useState } from "react";
import axios from "../api/axios";
import { createPortal } from "react-dom";

export default function ProveedorInput({ value, onChange }) {
  const [lista, setLista] = useState([]);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });

  const refInput = useRef(null);
  const portalRoot = document.getElementById("portal");

  // Buscar proveedores
  const buscar = async (texto) => {
    if (!texto) {
      const r = await axios.get(`/proveedores-simple`);
      setLista(r.data);
      return;
    }
    const r = await axios.get(`/proveedores-simple?q=${texto}`);
    setLista(r.data);
  };

  // Al escribir
  const handleChange = (e) => {
    const v = e.target.value;
    onChange(v);
    buscar(v);
    calcularPosicion();
    setOpen(true);
  };

  // Posicionar lista flotante
  const calcularPosicion = () => {
    const rect = refInput.current.getBoundingClientRect();
    setPos({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
    });
  };

  // Cuando seleccionas un proveedor
  const seleccionar = async (nombre) => {
    onChange(nombre);
    setOpen(false);

    // Crear proveedor SOLO cuando seleccionas uno que NO existe
    await axios.post("/proveedores-simple", { nombre });
  };

  return (
    <>
      <input
        ref={refInput}
        className="glass-input"
        value={value}
        placeholder="Proveedor"
        onChange={handleChange}
        onFocus={() => {
          buscar(value);
          calcularPosicion();
          setOpen(true);
        }}
        onBlur={() => setTimeout(() => setOpen(false), 120)}
      />

      {open && lista.length > 0 &&
        createPortal(
          <div
            style={{
              position: "absolute",
              top: pos.top,
              left: pos.left,
              width: pos.width,
              zIndex: 99999,
              maxHeight: 200,
              overflowY: "auto",
              borderRadius: 10,
              background: "rgba(30,30,40,0.95)",
              boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
              backdropFilter: "blur(10px)",
              color: "white",
            }}
            className="glass-box"
          >
            {lista.map((p) => (
              <div
                key={p.id}
                onMouseDown={() => seleccionar(p.nombre)}
                className="hover-item"
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                  transition: "0.15s",
                }}
              >
                {p.nombre}
              </div>
            ))}
          </div>,
          portalRoot
        )}
    </>
  );
}
